/* eslint-disable jsx-a11y/anchor-is-valid */
import { Component } from "react";
import {set_datapage, SetLanguage, getLanguage} from '@ora/recursos/src/redux/actions/DataPageAction'
import { connect } from "react-redux";
import numeral from "numeral";
import ModalBox from "layouts/mainsection/components/ModalBox";
import ModalCard from "layouts/mainsection/components/ModalCard";



class MTDDetallesBase extends Component {
  constructor (props) {
    super(props)
    // console.log('this.props.data', props.data)
  }
  componentDidMount() {
    // console.log('this.props.data', this.props.data)
  }
  render() {
    return <ModalCard
      id={ this.props.id }
      title={ this.props.title }
      // footer={ false }
      showButtons={ false }
    >
      <article className="media">
        <div className="media-content">
          <div className="table-wrapper has-mobile-cards table-container">
          <table className="table is-fullwidjth db-trafico is-striped is-hoverable" style={ {margin: '0 auto'} }>
            <thead>
              <tr>
                <th className="is-upper">{ this.props.language('pais') }</th>
                <th className="is-upper">{ this.props.language('cantidad') }</th>
              </tr>
            </thead>
            <tbody>
              {
                this.props.data.map((item, index) => {
                  return (
                    <tr key={ 'MTDDetallesBase' + this.props.id + index }>
                      <td>{ item[0] }</td>
                      <td className="has-text-centered">{ item[1] }</td>
                    </tr>
                  )
                })
              }
            </tbody>
          </table>
          </div>
        </div>

      </article>
    </ModalCard>
  }
}

export default connect(getLanguage, {set_datapage, SetLanguage})(MTDDetallesBase)
